export default ({axios, withoutInvalidValues}) => ({
    assignInvitations: (userId, body) => axios.post(`/users/${userId}/assign-invitations`, withoutInvalidValues(body)),
    enableUser: (userId, body = {}) => axios.patch(`/users/${userId}/enable`, withoutInvalidValues(body)),
    validateInstagram: (userId, body = {}) => axios.post(`/users/${userId}/validate-ig`, withoutInvalidValues(body)),
    reject: (userId, rejectReason) => axios.patch(`/users/${userId}/reject`, {
        reason: rejectReason
    }),
    updateIg: (userId) => axios.post(`/users/${userId}/update-ig-data`)
})
